import create from 'zustand'

const useStore = create((set) => ({
  agent: {
    onLine: false,
    userSIP:'',
    domain:'',
  },
  //call that I accept
  call:{
    thereIs: false,
    data: null,
    ended: false,
  },
  //call that I received, (phone is ringing)
  invitation:{
    thereIs: false,
    data: null,
    rejected: false,
    cancelled: false
  },
  //call that I made
  outgoingCall:{
    thereIs: false,
    data: null,
    ended: false,
    accepted: false
  },
  agentRegistered: () => set((state) => ({ agent: {...state.agent, onLine: true} })),
  agentUnRegistered: () => set((state) => ({ agent: {...state.agent, onLine: false} })),

  receiveInvitation: (invitation) => set(() => ({ invitation: {thereIs: true, data: invitation, rejected: false, cancelled: false} })),
  acceptInvitation: (invitation) => set(() => ({ 
    invitation: {thereIs: false, data: null, rejected: false, cancelled: false},
    call: { thereIs: true, data: invitation, ended: false }
   } )),

  invite: (invitation) => set(() => ({ outgoingCall: {thereIs: true, data: invitation, ended: false, accepted: false} })),
  outgoingCallAccepted: () => set((state) => ({ outgoingCall: {...state.outgoingCall, accepted: true} })),

  //firstly we put rejected or ended on true, so we could show "Call finished or Call rejected"
  reject: () => set((state) => ({ invitation: {...state.invitation, rejected: true} })),
  end: () => set((state) => ({ call: {...state.call, ended: true} })),
  endOutgoing: () => set((state) => ({ outgoingCall: {...state.outgoingCall, ended: true} })),
  cancel: () => set((state) => ({ invitation: {...state.invitation, cancelled: true} })),

  //after that, we clean up all invitation or call data
  endInvitation: () => set(() => ({ invitation: {thereIs: false, data: null, rejected: false, cancelled: false} })),
  endCall: () => set(() => ({ call: {thereIs: false, data: null, ended: false} })),
  endOutgoingCall: () => set(() => ({ outgoingCall: {thereIs: false, data: null, ended: false, accepted: false} })),
}))

export default useStore;